import axios from 'axios';
import { deleteMethodWithoutToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_REGISTER_PROFESSIONAL_CATEGORY =
  'DELETE_REGISTER_PROFESSIONAL_CATEGORY';
export const DELETE_REGISTER_PROFESSIONAL_CATEGORY_SUCCESS =
  'DELETE_REGISTER_PROFESSIONAL_CATEGORY_SUCCESS';
export const DELETE_REGISTER_PROFESSIONAL_CATEGORY_FAILURE =
  'DELETE_REGISTER_PROFESSIONAL_CATEGORY_FAILURE';

// Action Creators
export const deleteRegisterProfessionalCategory = () => ({
  type: DELETE_REGISTER_PROFESSIONAL_CATEGORY,
});

export const deleteRegisterProfessionalCategorySuccess = (users) => ({
  type: DELETE_REGISTER_PROFESSIONAL_CATEGORY_SUCCESS,
  payload: users,
});

export const deleteRegisterProfessionalCategoryFailure = (error) => ({
  type: DELETE_REGISTER_PROFESSIONAL_CATEGORY_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteRegisterProfessionalCategoryData = (
  data,
  external,
  role
) => {
  return async (dispatch) => {
    dispatch(deleteRegisterProfessionalCategory());
    try {
      let deleteUrl =
        url?.deleteRegisterProfessionalCategory +
        data.sub_practice_id +
        '/?doctor_id=' +
        data.doctor_id +
        '&request_id=' +
        data.request_id;

      const response = await deleteMethodWithoutToken(deleteUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteRegisterProfessionalCategorySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deleteRegisterProfessionalCategoryFailure('error?.message'));
      }
    } catch (error) {
      dispatch(deleteRegisterProfessionalCategoryFailure(error?.message));
    }
  };
};
